import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const SuperSystem = loadable(() => pMinDelay(import('./SuperSystem'), 300), {
  fallback: <Loading />
});

const AsyncSuperSystem = props => {
  const pageConfig = {
    headerType: 'mobile-none',
    footerType: 'mobile-none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } bg-green hide-betslip hide-sticky-navigation`
      },
      title: 'Bilyoner.com | Süper Sistem'
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <SuperSystem { ...props }/>
    </ApplicationLayout>
  );
};

AsyncSuperSystem.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncSuperSystem;
